module.exports = __webpack_public_path__ + "static/media/Instrumentaiton Cable.d9cadda1.png";